import { redactObject, safeComponentStack } from './redaction';

const ALLOWED_ERROR_FIELDS = new Set([
  'source',
  'errorName',
  'reasonCode',
  'componentStack',
  'event',
]);

/**
 * Local/privacy-safe client error reporter.
 * Production: no network sink; optional silent boundary.
 * Development: redacted console diagnostics only.
 *
 * @param {Record<string, unknown>} payload
 */
export function reportClientError(payload) {
  const safePayload = redactObject({
    event: 'client_error',
    source: payload?.source || 'unknown',
    errorName: payload?.errorName || 'Error',
    reasonCode: payload?.reasonCode || 'render_error',
    componentStack: safeComponentStack(
      typeof payload?.componentStack === 'string' ? payload.componentStack : '',
    ),
  });

  const filtered = {};
  Object.entries(safePayload).forEach(([key, value]) => {
    if (ALLOWED_ERROR_FIELDS.has(key)) {
      filtered[key] = value;
    }
  });

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.error('[client-error]', filtered);
  }
}
